module.exports = __webpack_public_path__ + "static/media/ic_06_highavailibility.185726e1.svg";